module.exports = __webpack_public_path__ + "img/FR10188.4d6a1a7a.png";